import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { ButtonComponent, EmptyStateComponent, LinkComponent } from '@pure/hive';
import { Angulartics2Module } from 'angulartics2';

import { AlertsSharedModule } from '../messages/alerts/alerts.shared.module';
import { UIModule } from '../ui/ui.module';

import { CaseManager } from './services/case-data.service';
import { SupportErrorService } from './services/error.service';
import { SupportContactService } from './services/support-contact.service';
import { CaseService } from './services/case.service';
import { SupportCaseOrchestratorService } from './services/support-case-orchestrator.service';
import { SupportUpgradeModule } from './support-upgrade/support-upgrade.module';
import { SafeModeModule } from '../safemode/safemode.module';
import { AuthorizerModule } from '@pure/authz-authorizer';
import { SupportRoutingModule } from './support-routing.module';

@NgModule({
    imports: [
        AlertsSharedModule,
        AuthorizerModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        UIModule,
        Angulartics2Module,
        SupportUpgradeModule,
        SafeModeModule,
        SupportRoutingModule,
        EmptyStateComponent,
        ButtonComponent,
        LinkComponent,
    ],
    providers: [CaseManager, CaseService, SupportContactService, SupportErrorService, SupportCaseOrchestratorService],
})
export class SupportModule {}
